import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import cuid from 'cuid';
import { ToggleInputLabelled } from '../ToggleInput/ToggleInputLabelled.js';
import { RadioInput } from './RadioInput.js';

var Radio = forwardRef(function (props, ref) {
    var children = props.children, _a = props.id, id = _a === void 0 ? cuid() : _a, label = props.label, _b = props.size, size = _b === void 0 ? "md" : _b, sx = props.sx, className = props.className, disabled = props.disabled, hideLabel = props.hideLabel, rest = __rest(props, ["children", "id", "label", "size", "sx", "className", "disabled", "hideLabel"]);
    return (jsx(ToggleInputLabelled, __assign({ sx: sx, className: className, id: id, label: label, size: size, disabled: disabled, hideLabel: hideLabel, input: jsx(RadioInput, __assign({ ref: ref, id: id, size: size, disabled: disabled }, rest)) }, { children: children })));
});
Radio.displayName = "Radio";

export { Radio };
//# sourceMappingURL=Radio.js.map
